module.exports = __webpack_public_path__ + "img/planet-mars.b55a334c.svg";